<template>
    <span class="d-flex flex-column mx-auto">
        <img src="/images/logo_top.png" alt="" class="logo-img mb-1 my-md-2">
        <img src="/images/logo_bottom.png" alt="" class="logo-img my-md-2">
    </span>
</template>

<script>
export default {
  name: 'Logo',
  data: () => ({})
}
</script>

<style lang="scss">
    .logo-img{
        width: 15vw;
        @include phone{
            width: 40vw;
        }
    }
</style>